import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

class NavigationLink extends Component {
  render() {
    const style = { textDecoration: 'none' };

    return (
      <Link to={this.props.to} style={style} onClick={this.props.onClick}>
        {this.props.children}
      </Link>
    );
  }
}

NavigationLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NavigationLink;
